(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riot-order-support"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const picker = root.querySelector('[data-order-picker]');
    const select = root.querySelector('[data-order-select]');
    const panels = [...root.querySelectorAll('[data-order-panel]')];
    const request = root.querySelector('[data-request-container]');
    const dialog = root.querySelector('[data-support-dialog]');
    const content = root.querySelector('[data-dialog-content]');
    const type = root.querySelector('[data-request-type]');
    const orderInput = root.querySelector('[data-request-order]');
    const itemInput = root.querySelector('[data-request-item]');
    const contextInput = root.querySelector('[data-request-context]');
    const manualDetails = root.querySelector('[data-manual-request]');
    const warning = root.querySelector('[data-manual-warning]');
    const form = request.querySelector('form');
    const sendButton = form?.querySelector('[data-request-send]');
    const items = [...root.querySelectorAll('[data-order-item]')];
    let manualEntry = !!manualDetails;
    let requestItem = null;
    let allowManualSubmit = false;
    let warningOpener = null;
    let activeItem = null;
    let activeDetails = null;
    let opener = null;
    let requestState = null;
    const success = root.querySelector('[data-form-success]');
    const errors = root.querySelector('[data-form-errors]');
    if (picker) {
      picker.hidden = false;
      panels.forEach(panel => { panel.hidden = true; });
      if (!success && !errors) request.hidden = true;
      select.addEventListener('change', () => {
        panels.forEach(panel => { panel.hidden = panel.dataset.orderPanel !== select.value; });
      });
    }
    const modalSupported = typeof dialog.showModal === 'function';
    if (modalSupported) root.querySelectorAll('[data-item-details]').forEach(details => { details.hidden = true; });
    function restore() {
      if (activeDetails && activeItem) {
        activeDetails.hidden = true;
        activeItem.append(activeDetails);
      }
      activeDetails = null;
      activeItem = null;
      if (opener?.isConnected) opener.focus();
      opener = null;
    }
    dialog.addEventListener('close', restore);
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    function constrain(state) {
      requestState = state;
      if (!type) return;
      type.querySelector('[value="cancel"]').disabled = !!state && state !== 'unfulfilled';
      type.querySelector('[value="remaining"]').disabled = state !== 'partial';
      if (type.selectedOptions[0]?.disabled) type.value = 'status';
    }
    constrain(null);
    function openItem(item, trigger) {
      activeItem = item;
      activeDetails = item.querySelector('[data-item-details]');
      if (!modalSupported) {
        activeDetails.hidden = false;
        item.closest('[data-order-panel]').hidden = false;
        activeDetails.scrollIntoView({block: 'center'});
        activeDetails = null;
        activeItem = null;
        return;
      }
      opener = trigger;
      root.querySelector('[data-dialog-title]').textContent = item.dataset.item;
      activeDetails.hidden = false;
      content.append(activeDetails);
      dialog.showModal();
      dialog.querySelector('[data-dialog-close]').focus();
    }
    function revealRequest() {
      if (manualDetails) manualDetails.open = true;
      request.hidden = false;
    }
    root.addEventListener('click', event => {
      const close = event.target.closest('[data-dialog-close]');
      if (close) { dialog.close(); return; }
      const open = event.target.closest('[data-item-open]');
      if (open && modalSupported) {
        event.preventDefault();
        openItem(open.closest('[data-order-item]'), open);
        return;
      }
      const action = event.target.closest('[data-request]');
      if (action && type) {
        event.preventDefault();
        const item = activeItem || action.closest('[data-order-item]');
        if (!item) return;
        const data = item.dataset;
        manualEntry = false;
        requestItem = item;
        orderInput.value = data.order;
        itemInput.value = data.item;
        contextInput.value = `Item ID: ${data.itemId}; Supplier: ${data.supplier || 'Needs verification'}; Page status: ${data.state}; Ordered quantity: ${data.quantity}; Remaining quantity for review: ${data.remaining}. Verify current Shopify order before any action.`;
        constrain(data.state);
        type.value = action.dataset.request;
        if (type.selectedOptions[0]?.disabled) type.value = 'status';
        if (dialog.open) { dialog.close(); restore(); }
        revealRequest();
        request.querySelector('[data-request-heading]').focus();
        request.scrollIntoView({block:'start', behavior:'instant'});
      }
    });
    [orderInput, itemInput].filter(Boolean).forEach(input => input.addEventListener('input', () => {
      manualEntry = true;
      requestItem = null;
      contextInput.value = 'Customer entered order/item details. Verify identity, fulfillment and supplier before action.';
      constrain(null);
    }));
    type?.addEventListener('change', () => constrain(requestState));
    function closeWarning() {
      if (typeof warning.close === 'function') warning.close();
      else warning.removeAttribute('open');
      warning.hidden = true;
      if (warningOpener?.isConnected) warningOpener.focus();
      warningOpener = null;
    }
    warning.querySelectorAll('[data-warning-close]').forEach(button => button.addEventListener('click', closeWarning));
    warning.addEventListener('cancel', event => { event.preventDefault(); closeWarning(); });
    warning.addEventListener('click', event => { if (event.target === warning) closeWarning(); });
    const normalize = value => value.trim().replace(/^#/, '').replace(/\s+/g, ' ').toLowerCase();
    function reviewBeforeSend(trigger, confirmed = false) {
      if (!type || !['cancel', 'remaining'].includes(type.value)) return true;
      const matches = items.filter(item => normalize(item.dataset.order) === normalize(orderInput.value) && normalize(item.dataset.item) === normalize(itemInput.value));
      const knownItem = manualEntry ? (matches.length === 1 ? matches[0] : null) : requestItem;
      if (knownItem && (['fulfilled', 'closed', 'review_status'].includes(knownItem.dataset.state) || (knownItem.dataset.state === 'partial' && type.value === 'cancel'))) {
        openItem(knownItem, trigger);
        return false;
      }
      if (!manualEntry || confirmed) return true;
      warningOpener = trigger;
      warning.hidden = false;
      if (typeof warning.showModal === 'function') warning.showModal();
      else { warning.classList.add('ros-warning--inline'); warning.setAttribute('open', ''); warning.scrollIntoView({block: 'center'}); }
      warning.querySelector('[data-warning-close]').focus();
      return false;
    }
    function attemptSend(confirmed = false) {
      if (!form || !form.reportValidity() || !reviewBeforeSend(sendButton, confirmed)) return;
      allowManualSubmit = true;
      try { form.requestSubmit(); } finally { allowManualSubmit = false; }
    }
    // Review before starting native submission: platform/app handlers may call
    // form.submit() directly, which doesn't dispatch another submit event.
    if (sendButton) {
      sendButton.type = 'button';
      sendButton.addEventListener('click', event => {
        event.preventDefault();
        attemptSend();
      });
    }
    form?.addEventListener('keydown', event => {
      if (event.key !== 'Enter' || event.isComposing || event.ctrlKey || event.altKey || event.metaKey || event.shiftKey || !event.target.matches('input:not([type="checkbox"]):not([type="button"]):not([type="submit"])')) return;
      event.preventDefault();
      attemptSend();
    }, true);
    form?.addEventListener('submit', event => {
      if (allowManualSubmit || reviewBeforeSend(event.submitter || sendButton)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
    warning.querySelector('[data-warning-send]').addEventListener('click', () => {
      if (warning.hidden || !form) return;
      closeWarning();
      attemptSend(true);
    });
    if (success) { revealRequest(); success.focus(); }
    if (errors) { revealRequest(); errors.scrollIntoView({block:'center'}); }
    root.querySelectorAll('[data-sign-in]').forEach(signin => {
      const current = new URL(window.location.href);
      const returnTo = new URL(current.pathname, current.origin);
      for (const key of ['view', 'preview_theme_id']) if (current.searchParams.has(key)) returnTo.searchParams.set(key, current.searchParams.get(key));
      const login = new URL(signin.href);
      login.searchParams.set('return_to', returnTo.pathname + returnTo.search);
      signin.href = login.pathname + login.search;
    });
  }
  document.querySelectorAll('[data-order-support]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-order-support]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();
})();
